// extracted by mini-css-extract-plugin
export default {"nhima-header":"NhimaReport_nhima-header__cDLd+","divider":"NhimaReport_divider__KUt9F"};